import { Role } from "@libs/interfaces/layouts";

export const getExpertRoles = (): Role[] => {
    return [ "Track_moderator", "School_guardian", "Expert" ]
}